/**
 * Fetch with timeout - prevents infinite spinners when API hangs
 * 
 * @param {string} url - URL to fetch
 * @param {object} options - Fetch options
 * @param {number} timeoutMs - Timeout in milliseconds (default 8000)
 * @returns {Promise<Response|null>} - Response or null if timed out
 */
export async function fetchWithTimeout(url, options = {}, timeoutMs = 8000) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(id);
    return response;
  } catch (err) {
    clearTimeout(id);
    if (err.name === 'AbortError') {
      console.warn(`Request to ${url} timed out after ${timeoutMs}ms`);
      return null;
    }
    throw err;
  }
}

export default fetchWithTimeout;
